import { useFilterBranchContext } from "./filter-branch.context";

export function FilterBranch() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterBranchContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}